export default __webpack_public_path__ + "static/media/banner_3_2W.7b83776b.jpg";